<script lang="ts" setup>
    import { ref, onMounted, watch } from 'vue'
    // import axios from '@/utils/apiClient'
    import axios from '@/utils/apiClient'

    const props = defineProps({
        modelValue: {
            type: Number,
            default: null,
        },
        prop: {
            type: String,
            default: null,
        },
    })

    const emit = defineEmits(['update:modelValue'])

    const data = ref([])
    const value = ref(props.modelValue)

    const fetch = async () => {
        const res = await axios.get('ComparisonOperator')
        data.value = res.data
    }

    onMounted(() => {
        fetch()
    })

    watch(
        () => props.modelValue,
        newValue => {
            value.value = newValue
        }
    )

    watch(value, newValue => {
        emit('update:modelValue', newValue)
    })
</script>

<template>
    <el-form-item label="Compare" :prop="prop">
        <el-select size="large" clearable class="w-100" v-model="value" placeholder="Select" style="width: 240px">
            <el-option v-for="item in data" :key="item.id" :label="item.description" :value="item.id" />
        </el-select>
    </el-form-item>
</template>
